<template>
  <div>
    <div class="dropdown-wrapper" ref="dropdown">
      <span @click="toggleDropdown">
        <slot></slot>
      </span>

      <v-card v-show="showDropdown" class="dropdown-content">
        <v-list class="py-0">
          <div v-for="(item, i) in deliveryMethods" :key="i">
            <v-list-item
              @click="
                $emit('submit', item.id);
                showDropdown = false;
              "
            >
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
            </v-list-item>
            <v-divider v-if="deliveryMethods.length - 1 != i" />
          </div>
        </v-list>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    deliveryMethods() {
      return this.$store.getters.deliveryMethods;
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  },
  mounted() {
    window.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style scoped>
.dropdown-wrapper {
  position: relative;
  display: inline-block;
  z-index: 10;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 160px;
  z-index: 10;
}
</style>
